import { t } from 'i18next'
import * as React from 'react'
import { InView } from 'react-intersection-observer'
import { getClassName } from '../../components/cms/blocks/utils.gen'
import { blockInviewHandler } from '../../components/drupal/rendering/inview_utils.mod'
import { ExternalLink } from '../../components/publicSite/utils/external_link'
import { FieldSetLegend, FormElement, FormGroup, FormStyle } from '../../components/publicSite/utils/forms'
import { sluggify, titleSplit } from '../../components/publicSite/utils/helpers'
import { allLanguages } from '../../components/publicSite/utils/history.mod'

export const fakeContactForm = (options: { style: FormStyle }, thankYou: boolean) => (
  <InView
    as="section"
    onChange={(inView) =>
      blockInviewHandler('contactForm', inView, 'io-contact-form', getClassName(options, 'inview_classname', 'inview'))
    }
    triggerOnce={true}
    threshold={0.1}
    id="io-contact-form"
    className={getClassName(options, 'block_classname', '')}
  >
    <div className={getClassName(options, 'inner_classname', '')}>
      <header className={getClassName(options, 'header_classname', '')}>
        <h2 className={getClassName(options, 'title_classname', '')}>{titleSplit(t('ContactForm:Texts.Title'))} </h2>
      </header>

      {thankYou ? (
        // Thank you page
        <div className={getClassName(options, 'content_classname', '')}>
          <p>{t('ContactForm:ThankYouMessage')}</p>
        </div>
      ) : (
        <div className={getClassName(options, 'content_classname', '')}>
          {t('ContactForm:Texts.Intro') != '' && (
            <div className={getClassName(options, 'intro_classname', '')}>
              <p>{t('ContactForm:Texts.Intro')}</p>
            </div>
          )}

          {t('ContactForm:Texts.SubTitle') != '' && (
            <h3 className={getClassName(options, 'subtitle_classname', '')}>{t('ContactForm:Texts.SubTitle')}</h3>
          )}

          <form
            className={getClassName(options, 'form_classname', '')}
            noValidate={true}
            onSubmit={(e) => console.log(e)}
          >
            {/* Full name */}
            <FormElement
              formGroupExtraClasses="form__group--error"
              labelProps={{
                htmlAttributes: { htmlFor: 'contact-form-fullname' },
                label: t('Form:Fields.FullName')
              }}
              elementProps={{
                kind: 'input',
                htmlAttributes: {
                  id: 'contact-form-fullname',
                  required: true,
                  autoComplete: 'name',
                  'aria-describedby': 'a11y-contact-form-fullname-error',
                  'aria-invalid': true,
                  value: '',
                  onChange: (e) => console.log(e)
                }
              }}
              errorMessageProps={{
                id: 'a11y-contact-form-fullname-error',
                message: t('Form:Errors.NoName')
              }}
            />

            {/* Email address */}
            <FormElement
              labelProps={{
                htmlAttributes: { htmlFor: 'contact-form-email' },
                label: t('Form:Fields.Email')
              }}
              elementProps={{
                kind: 'input',
                htmlAttributes: {
                  id: 'contact-form-email',
                  required: true,
                  inputMode: 'email',
                  autoComplete: 'email',
                  value: '',
                  onChange: (e) => console.log(e)
                }
              }}
            />

            {/* Phone number */}
            <FormElement
              labelProps={{
                htmlAttributes: { htmlFor: 'contact-form-phone' },
                label: t('Form:Fields.Phone')
              }}
              elementProps={{
                kind: 'input',
                htmlAttributes: {
                  id: 'contact-form-phone',
                  required: false,
                  inputMode: 'tel',
                  autoComplete: 'tel',
                  value: '',
                  onChange: (e) => console.log(e)
                }
              }}
            />

            {/* Country */}
            <FormElement
              labelProps={{
                htmlAttributes: { htmlFor: 'contact-form-country' },
                label: t('Form:Fields.Country.Title')
              }}
              elementProps={{
                kind: 'select',
                options: allLanguages.map((locale) => ({
                  value: locale,
                  text:
                    locale == 'global'
                      ? t('Form:Fields.Country.Placeholder')
                      : t(`Form:Fields.Country.Options.${locale}`),
                  disabled: locale == 'global'
                })),
                htmlAttributes: {
                  id: 'contact-form-country',
                  required: true,
                  value: 'global',
                  onChange: (e) => console.log(e)
                }
              }}
              descriptionProps={{
                id: 'a11y-contact-form-country-description',
                message: t('Form:Fields.Country.Info')
              }}
            />

            {/* ZIP code */}
            <FormElement
              labelProps={{
                htmlAttributes: { htmlFor: 'contact-form-zip' },
                label: t('Form:Fields.ZipCode')
              }}
              elementProps={{
                kind: 'input',
                htmlAttributes: {
                  id: 'contact-form-zip',
                  required: false,
                  autoComplete: 'postal-code',
                  value: '',
                  onChange: (e) => console.log(e)
                }
              }}
            />

            {/* Subject */}
            <FormElement
              labelProps={{
                htmlAttributes: { htmlFor: 'contact-form-subject' },
                label: t('ContactForm:Fields.Subject.Title')
              }}
              elementProps={{
                kind: 'select',
                options: [
                  { text: t('ContactForm:Fields.Subject.Placeholder'), htmlAttributes: { disabled: true } },
                  { text: t('ContactForm:Fields.Subject.Options.Option1') },
                  { text: t('ContactForm:Fields.Subject.Options.Option2') },
                  { text: t('ContactForm:Fields.Subject.Options.Option3') },
                  { text: t('ContactForm:Fields.Subject.Options.Option4') }
                ],
                htmlAttributes: {
                  id: 'contact-form-subject',
                  required: true,
                  value: t('ContactForm:Fields.Subject.Placeholder'),
                  onChange: (e) => console.log(e)
                }
              }}
            />

            {/* Message */}
            <FormElement
              labelProps={{
                htmlAttributes: { htmlFor: 'contact-form-message' },
                label: t('ContactForm:Fields.Message')
              }}
              elementProps={{
                kind: 'textArea',
                htmlAttributes: {
                  id: 'contact-form-message',
                  required: false,
                  rows: 5,
                  value: '',
                  onChange: (e) => console.log(e)
                }
              }}
            />

            {/* Accept terms */}
            <FormElement
              labelProps={{
                htmlAttributes: {
                  htmlFor: 'contact-form-accept-terms'
                },
                label: t('Form:Fields.Terms.Text')
              }}
              elementProps={{
                kind: 'boolean',
                htmlAttributes: {
                  type: 'checkbox',
                  id: 'contact-form-accept-terms',
                  required: true,
                  checked: false,
                  onChange: (e) => console.log(e)
                }
              }}
            />

            <div className={getClassName(options, 'footer_classname', '')}>
              <div className={getClassName(options, 'clickable_wrapper_classname', '')}>
                <button type="submit" className={getClassName(options, 'clickable_primary_classname', '')}>
                  {t('ContactForm:Submit.Text')}
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  </InView>
)

export const fakeBimForm = (options: { style: FormStyle }, thankYou: boolean) => (
  <InView
    as="section"
    onChange={(inView) =>
      blockInviewHandler('bimForm', inView, 'io-bim-form', getClassName(options, 'inview_classname', 'inview'))
    }
    triggerOnce={true}
    threshold={0.1}
    id="io-bim-form"
    className={getClassName(options, 'block_classname', '')}
  >
    <div className={getClassName(options, 'inner_classname', '')}>
      <header className={getClassName(options, 'header_classname', '')}>
        <h2 className={getClassName(options, 'title_classname', '')}>
          {titleSplit(t('BimAndDrawingsForm:Texts.FormTitle'))}
        </h2>
      </header>

      {!thankYou ? (
        <div className={getClassName(options, 'content_classname', '')}>
          {(t('BimAndDrawingsForm:Texts.Intro.Text') !== '' ||
            t('BimAndDrawingsForm:Texts.Intro.BoldText') !== '' ||
            t('BimAndDrawingsForm:Texts.Intro.ListItem1') !== '' ||
            t('BimAndDrawingsForm:Texts.Intro.ListItem2') !== '') && (
            <div className={getClassName(options, 'intro_classname', '')}>
              {t('BimAndDrawingsForm:Texts.Intro.Text') !== '' && <p>{t('BimAndDrawingsForm:Texts.Intro.Text')}</p>}

              {t('BimAndDrawingsForm:Texts.Intro.BoldText') !== '' &&
                (t('BimAndDrawingsForm:Texts.Intro.ListItem1') !== '' ||
                  t('BimAndDrawingsForm:Texts.Intro.ListItem2') !== '') && (
                  <>
                    <p>
                      <b>{t('BimAndDrawingsForm:Texts.Intro.BoldText')}</b>
                    </p>
                    <ul>
                      {t('BimAndDrawingsForm:Texts.Intro.ListItem1') !== '' && (
                        <li>{t('BimAndDrawingsForm:Texts.Intro.ListItem1')}</li>
                      )}
                      {t('BimAndDrawingsForm:Texts.Intro.ListItem2') !== '' && (
                        <li>{t('BimAndDrawingsForm:Texts.Intro.ListItem2')}</li>
                      )}
                    </ul>
                  </>
                )}
            </div>
          )}

          <form
            className={getClassName(options, 'form_classname', '')}
            noValidate={true}
            onSubmit={(e) => console.log(e)}
          >
            {/* Your request */}
            {t('BimAndDrawingsForm:Texts.SubTitleYourRequest') != '' && (
              <h3 className={getClassName(options, 'subtitle_classname', '')}>
                {t('BimAndDrawingsForm:Texts.SubTitleYourRequest')}
              </h3>
            )}

            {/* Document Type */}
            <FormGroup reversed={true}>
              <FieldSetLegend alignRow={true} legend={t('BimAndDrawingsForm:Fields.DocumentSelector.Title')}>
                <FormElement
                  labelProps={{
                    htmlAttributes: { htmlFor: 'bim-form-document-type-bim-object' },
                    label: t('BimAndDrawingsForm:Fields.DocumentSelector.BIMobject')
                  }}
                  elementProps={{
                    kind: 'boolean',
                    htmlAttributes: {
                      type: 'radio',
                      name: 'bim-form-document-type',
                      id: 'bim-form-document-type-bim-object',
                      required: true,
                      onChange: (e) => console.log(e)
                    }
                  }}
                />
                <FormElement
                  labelProps={{
                    htmlAttributes: { htmlFor: 'bim-form-document-type-tech-drawing' },
                    label: t('BimAndDrawingsForm:Fields.DocumentSelector.TechDrawings')
                  }}
                  elementProps={{
                    kind: 'boolean',
                    htmlAttributes: {
                      type: 'radio',
                      name: 'bim-form-document-type',
                      id: 'bim-form-document-type-tech-drawing',
                      required: true,
                      onChange: (e) => console.log(e)
                    }
                  }}
                />
                <FormElement
                  labelProps={{
                    htmlAttributes: { htmlFor: 'bim-form-document-type-both' },
                    label: t('BimAndDrawingsForm:Fields.DocumentSelector.Both')
                  }}
                  elementProps={{
                    kind: 'boolean',
                    htmlAttributes: {
                      type: 'radio',
                      name: 'bim-form-document-type',
                      id: 'bim-form-document-type-both',
                      required: true,
                      onChange: (e) => console.log(e)
                    }
                  }}
                />
              </FieldSetLegend>
            </FormGroup>

            {/* Available Products */}
            <FormGroup reversed={true}>
              <FieldSetLegend legend={t('BimAndDrawingsForm:Fields.ProductSelector.Title')} alignRow={false}>
                {['Product 1', 'Product 2', 'Product 3'].map<JSX.Element>((product) => (
                  <FormElement
                    labelProps={{
                      htmlAttributes: { htmlFor: sluggify(`bim-form-${product}-selection`) },
                      label: product
                    }}
                    elementProps={{
                      kind: 'boolean',
                      htmlAttributes: {
                        type: 'checkbox',
                        id: sluggify(`bim-form-${product}-selection`),
                        required: true
                      }
                    }}
                  />
                ))}
              </FieldSetLegend>
            </FormGroup>

            {/* Your contact information */}
            {t('BimAndDrawingsForm:Texts.SubTitleYourContactInfo') != '' && (
              <h3 className={getClassName(options, 'subtitle_classname', '')}>
                {t('BimAndDrawingsForm:Texts.SubTitleYourContactInfo')}
              </h3>
            )}

            {/* E-mail address */}
            <FormElement
              labelProps={{
                htmlAttributes: { htmlFor: 'bim-form-email' },
                label: t('Form:Fields.Email')
              }}
              elementProps={{
                kind: 'input',
                htmlAttributes: {
                  id: 'bim-form-email',
                  required: true,
                  inputMode: 'email',
                  autoComplete: 'email',
                  value: '',
                  onChange: (e) => console.log(e)
                }
              }}
            />

            {/* Country */}
            <FormElement
              labelProps={{
                htmlAttributes: { htmlFor: 'bim-form-country' },
                label: t('Form:Fields.Country.Title')
              }}
              elementProps={{
                kind: 'select',
                options: allLanguages.map((locale) => ({
                  text:
                    locale == 'global'
                      ? t('Form:Fields.Country.Placeholder')
                      : t(`Form:Fields.Country.Options.${locale}`),
                  optionElementProps: {
                    value: locale,
                    disabled: locale == 'global'
                  }
                })),
                htmlAttributes: {
                  id: 'bim-form-country',
                  required: true,
                  value: 'global',
                  onChange: (e) => console.log(e)
                }
              }}
              descriptionProps={{
                id: 'a11y-bim-form-country-description',
                message: t('Form:Fields.Country.Info')
              }}
            />

            {/* ZIP code */}
            <FormElement
              labelProps={{
                htmlAttributes: { htmlFor: 'bim-form-zip' },
                label: t('Form:Fields.ZipCode')
              }}
              elementProps={{
                kind: 'input',
                htmlAttributes: {
                  id: 'bim-form-zip',
                  required: false,
                  autoComplete: 'postal-code',
                  value: '',
                  onChange: (e) => console.log(e)
                }
              }}
            />

            {/* Accept terms */}
            <FormElement
              labelProps={{
                htmlAttributes: {
                  htmlFor: 'bim-form-accept-terms'
                },
                label: t('Form:Fields.Terms.Text')
              }}
              elementProps={{
                kind: 'boolean',
                htmlAttributes: {
                  type: 'checkbox',
                  id: 'bim-form-accept-terms',
                  required: true,
                  onChange: (e) => console.log(e)
                }
              }}
            />
            <div className={getClassName(options, 'footer_classname', '')}>
              <div className={getClassName(options, 'clickable_wrapper_classname', '')}>
                <button type="submit" className={getClassName(options, 'clickable_primary_classname', '')}>
                  {t('BimAndDrawingsForm:Submit.Text')}
                </button>
              </div>
            </div>
          </form>
        </div>
      ) : (
        // Thank you page
        <div className={getClassName(options, 'content_classname', '')}>
          <p>{t('BimAndDrawingsForm:ThankYou.Text')}</p>
          <div className={getClassName(options, 'footer_classname', '')}>
            <div className={getClassName(options, 'clickable_wrapper_classname', '')}>
              <ExternalLink type="link" className={getClassName(options, 'clickable_primary_classname', '')} to="#">
                {t('BimAndDrawingsForm:ThankYou.ReturnPrevious')}
              </ExternalLink>
            </div>
            <div className={getClassName(options, 'clickable_wrapper_classname', '')}>
              <ExternalLink type="link" className={getClassName(options, 'clickable_secondary_classname', '')} to="#">
                {t('BimAndDrawingsForm:ThankYou.ReturnProducts')}
              </ExternalLink>
            </div>
          </div>
        </div>
      )}
    </div>
  </InView>
)

// SREFC-111. The form building block has no composed artwork in Figma, so this
// renders the individual controls the Design System does define: Input (node 9:61
// and 61:20052), Select (9:73), Checkbox & Radio (10:6) and Alert (10:56).
//
// It uses the `FormElement` primitives from components/publicSite/utils/forms. The
// Fabric-rendered CMS block shares `.form__input`, `.form__label` and the panels
// but wraps them in `.ms-*` markup, so the dropdown, checkbox, radio and datepicker
// in the live block still have to be checked against a real form.

export const formFields = () => (
  <div className="form">
    <FormElement
      labelProps={{ htmlAttributes: { htmlFor: 'sg-form-name' }, label: 'Full name' }}
      elementProps={{
        kind: 'input',
        htmlAttributes: { id: 'sg-form-name', required: true, placeholder: 'Placeholder text' }
      }}
    />

    <FormElement
      labelProps={{ htmlAttributes: { htmlFor: 'sg-form-email' }, label: 'Email address' }}
      elementProps={{
        kind: 'input',
        htmlAttributes: { id: 'sg-form-email', required: true, defaultValue: 'name@refresco.com' }
      }}
      descriptionProps={{ id: 'sg-form-email-hint', message: 'This is a hint text to help user.' }}
    />

    <FormElement
      labelProps={{ htmlAttributes: { htmlFor: 'sg-form-disabled' }, label: 'Disabled' }}
      elementProps={{
        kind: 'input',
        htmlAttributes: { id: 'sg-form-disabled', required: true, disabled: true, placeholder: 'Placeholder text' }
      }}
    />

    <FormElement
      labelProps={{ htmlAttributes: { htmlFor: 'sg-form-subject' }, label: 'Subject' }}
      elementProps={{
        kind: 'select',
        options: [
          { text: 'Select an option', htmlAttributes: { disabled: true } },
          { text: 'Option A' },
          { text: 'Option B' }
        ],
        htmlAttributes: { id: 'sg-form-subject', required: true, defaultValue: 'Select an option' }
      }}
    />

    <FormElement
      labelProps={{ htmlAttributes: { htmlFor: 'sg-form-message' }, label: 'Message' }}
      elementProps={{
        kind: 'textArea',
        htmlAttributes: { id: 'sg-form-message', required: true, placeholder: 'Placeholder text' }
      }}
    />

    <FormElement
      formGroupExtraClasses="form__group--error"
      labelProps={{ htmlAttributes: { htmlFor: 'sg-form-invalid' }, label: 'Error state' }}
      elementProps={{
        kind: 'input',
        htmlAttributes: { id: 'sg-form-invalid', required: true, 'aria-invalid': true, defaultValue: '' }
      }}
      errorMessageProps={{ id: 'sg-form-invalid-error', message: 'This field is required.' }}
    />
  </div>
)

export const formToggles = () => (
  <div className="form">
    <FormElement
      labelProps={{ htmlAttributes: { htmlFor: 'sg-form-terms' }, label: 'I accept the terms and conditions' }}
      elementProps={{
        kind: 'boolean',
        htmlAttributes: { type: 'checkbox', id: 'sg-form-terms', required: true }
      }}
    />

    <FormElement
      labelProps={{ htmlAttributes: { htmlFor: 'sg-form-terms-checked' }, label: 'Checked by default' }}
      elementProps={{
        kind: 'boolean',
        htmlAttributes: { type: 'checkbox', id: 'sg-form-terms-checked', required: true, defaultChecked: true }
      }}
    />

    <FormElement
      labelProps={{ htmlAttributes: { htmlFor: 'sg-form-terms-disabled' }, label: 'Disabled' }}
      elementProps={{
        kind: 'boolean',
        htmlAttributes: { type: 'checkbox', id: 'sg-form-terms-disabled', required: true, disabled: true }
      }}
    />

    <FormElement
      labelProps={{ htmlAttributes: { htmlFor: 'sg-form-doc-bim' }, label: 'BIM object' }}
      elementProps={{
        kind: 'boolean',
        htmlAttributes: { type: 'radio', name: 'sg-form-doc', id: 'sg-form-doc-bim', required: true }
      }}
    />

    <FormElement
      labelProps={{ htmlAttributes: { htmlFor: 'sg-form-doc-drawings' }, label: 'Technical drawings' }}
      elementProps={{
        kind: 'boolean',
        htmlAttributes: {
          type: 'radio',
          name: 'sg-form-doc',
          id: 'sg-form-doc-drawings',
          required: true,
          defaultChecked: true
        }
      }}
    />
  </div>
)

export const formPanels = () => (
  <div className="form">
    <p className="form__thanks">Thank you, your message has been sent.</p>
    <br />
    <p className="message message--error">Something went wrong, please try again later.</p>
    <br />
    <button className="button button--primary">Send</button>
  </div>
)
